import Vue from 'vue'
import Vuex from 'vuex'

import api_calls from '@/modules/api_calls'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loggedIn: false
  },
  getters: {
    login: state => {
      return state.loggedIn
    }
  },
  mutations: {
  },
  actions: {
    async validateState(context) {
      let loggedData = window.sessionStorage.getItem('loggedIn') || null
      loggedData == null ? context.loggedIn = false : context.loggedIn = true
    },

    async collectAreas(context, app) {
      let method = "areas/listAll"
      let data = await api_calls.call_api_get(method)

      app.areas = Object.values(data.areas)
    },

    async createArea(context, app) {
      let method = "area/create"
      app.editedItem.color_code = app.editedItem.color_code.hexa
      let data = await api_calls.call_api_post(method, app.editedItem)

      app.createResult = data
      if (app.createResult.resultado != "OK") {
        app.areaMsg = app.createResult.details;
      } else {
        // app.areaMsg = "Aplicação criada com sucesso";
        app.close();
        app.initialize();
      }
    },

    async updateArea(context, app) {
      let method = "area/edit/"+app.editedItem.id
      let data = await api_calls.call_api_post(method, app.editedItem)

      app.updateResult = data
      if (app.updateResult.resultado != "OK") {
        app.areaMsg = app.updateResult.details;
      } else {
        // app.areaMsg = "Aplicação editada com sucesso";
        app.close();
        app.initialize();
      }
    },

    async deleteArea(context, app) {
      let method = "area/delete/"+app.editedItem.id
      let data = await api_calls.call_api_get(method)

      app.updateResult = data
      if (app.updateResult.resultado != "OK") {
        app.areaMsg = app.updateResult.details;
      } else {
        // app.areaMsg = "Aplicação editada com sucesso";
        app.close();
        app.initialize();
      }
    },



    async collectFamilies(context, app) {
      let method = "family/listAll"
      let data = await api_calls.call_api_get(method)

      app.families = Object.values(data.families)
    },

    async createFamilies(context, app) {
      let method = "family/create"
      let data = await api_calls.call_api_create_prod(method, app.form_data)

      app.createResult = data
      if (app.createResult.resultado != "OK") {
        app.familyMsg = app.createResult.details;
      } else {
        // app.functionMsg = "Função criada com sucesso";

        let images = ['img_1', 'img_2', 'img_3', 'video']
        let temp_form_data = new FormData()
        for(let i of images) {
          if(typeof app[i].name == 'string') {
            let img = app[i]
            temp_form_data.append('fotos', img);

            let res = await context.dispatch('upload_api', temp_form_data)

            console.log(res)
          }
        }
        app.close();
        app.initialize();
      }
    },

    async updateFamilies(context, app) {
      let method = "family/edit/"+app.editedItem.id
      let data = await api_calls.call_api_create_prod(method, app.form_data)

      app.updateResult = data
      if (app.updateResult.resultado != "OK") {
        app.familyMsg = app.updateResult.details;
      } else {
        // app.functionMsg = "Função editada com sucesso";

        let images = ['img_1', 'img_2', 'img_3', 'video']
        let temp_form_data = new FormData()
        for(let i of images) {
          if(typeof app[i].name == 'string') {
            let img = app[i]
            temp_form_data.append('fotos', img);

            let res = await context.dispatch('upload_api', temp_form_data)

            console.log(res)
          }
        }
        app.close();
        app.initialize();
      }
    },

    async deleteFamilies(context, app) {
      let method = "family/delete/"+app.deletedItem.id
      let data = await api_calls.call_api_get(method)

      app.updateResult = data
      if (app.updateResult.resultado != "OK") {
        app.familyMsg = app.updateResult.details;
      } else {
        // app.categoryMsg = "Marca editada com sucesso";

        let images = ['img_1', 'img_2', 'img_3', 'video']
        let temp_form_data = new FormData()
        for(let i of images) {
          if(typeof app[i].name == 'string') {
            let img = app[i]
            temp_form_data.append('fotos', img);

            let res = await context.dispatch('upload_api', temp_form_data)

            console.log(res)
          }
        }
        app.close();
        app.initialize();
      }
    },


    async collectCategories(context, app) {
      let method = "categories/listAll"
      let data = await api_calls.call_api_get(method)

      app.categories = Object.values(data.categories)
    },
    
    async createCategories(context, app) {
      let method = "category/create"
      let data = await api_calls.call_api_create_prod(method, app.form_data)

      app.createResult = data
      if (app.createResult.resultado != "OK") {
        app.categoryMsg = app.createResult.details;
      } else {
        // app.categoryMsg = "Marca criada com sucesso";

        let images = ['img_1', 'img_2', 'img_3', 'video']
        let temp_form_data = new FormData()
        for(let i of images) {
          if(typeof app[i].name == 'string') {
            let img = app[i]
            temp_form_data.append('fotos', img);

            let res = await context.dispatch('upload_api', temp_form_data)

            console.log(res)
          }
        }

        app.close();
        app.initialize();
      }
    },

    async updateCategories(context, app) {
      let method = "category/edit/"+app.editedItem.id
      let data = await api_calls.call_api_create_prod(method, app.form_data)

      app.updateResult = data
      if (app.updateResult.resultado != "OK") {
        app.categoryMsg = app.updateResult.details;
      } else {
        // app.categoryMsg = "Marca editada com sucesso";

        let images = ['img_1', 'img_2', 'img_3', 'video']
        let temp_form_data = new FormData()
        for(let i of images) {
          if(typeof app[i].name == 'string') {
            let img = app[i]
            temp_form_data.append('fotos', img);

            let res = await context.dispatch('upload_api', temp_form_data)

            console.log(res)
          }
        }
        app.close();
        app.initialize();
      }
    },

    async deleteCategories(context, app) {
      let method = "category/delete/"+app.deletedItem.id
      let data = await api_calls.call_api_get(method)

      app.updateResult = data
      if (app.updateResult.resultado != "OK") {
        app.categoryMsg = app.updateResult.details;
      } else {
        // app.categoryMsg = "Marca editada com sucesso";
        app.close();
        app.initialize();
      }
    },


    async collectUsers(context, app) {
      let method = "users/listAll"
      let data = await api_calls.call_api_get(method)

      app.users = Object.values(data.users)
    },

    async createUsers(context, app) {
      let method = "user/create"
      let data = await api_calls.call_api_post(method, app.editedItem)

      app.createResult = data
      if (app.createResult.resultado != "OK") {
        app.userMsg = app.createResult.details;
      } else {
        // app.categoryMsg = "Marca criada com sucesso";
        app.close();
        app.initialize();
      }
    },

    async updateUsers(context, app) {
      let method = "user/edit/"+app.editedItem.id
      let data = await api_calls.call_api_post(method, app.editedItem)

      app.updateResult = data
      if (app.updateResult.resultado != "OK") {
        app.userMsg = app.updateResult.details;
      } else {
        // app.categoryMsg = "Marca editada com sucesso";
        app.close();
        app.initialize();
      }
    },

    async deleteUser(context, app) {
      let method = "user/delete/"+app.deletedItem.id
      let data = await api_calls.call_api_get(method)

      app.updateResult = data
      if (app.updateResult.resultado != "OK") {
        app.categoryMsg = app.updateResult.details;
      } else {
        // app.categoryMsg = "Marca editada com sucesso";
        app.close();
        app.initialize();
      }
    },


    async logUserIn(context, app) {
      let method = "login-bo"
      let data = await api_calls.call_api_post(method, app.userData)

      if(data.resultado == "OK") {
        context.loggedIn = true
      }
      else {
        context.loggedIn = false
      }

      app.apiCallResult = data
    },

    
    async collectProducts(context, app) {
      let method = "product/listAll"
      let data = await api_calls.call_api_get(method)

      app.products = Object.values(data.products)
    },
    async createProducts(context, app) {
      let method = "product/create"
      let data = await api_calls.call_api_create_prod(method, app.form_data)

      app.createResult = data
      if (app.createResult.resultado != "OK") {
        app.productMsg = app.createResult.details;
      } else {
        // app.functionMsg = "Função criada com sucesso";

        let images = ['image_1', 'image_2', 'image_3', 'video']
        let temp_form_data = new FormData()
        for(let i of images) {
          if(typeof app[i].name == 'string') {
            let img = app[i]
            temp_form_data.append('fotos', img);

            let res = await context.dispatch('upload_api', temp_form_data)

            console.log(res)
          }
        }

        let files = ['link_1', 'link_2', 'link_3', 'link_4', 'link_5']
        let temp_form_data_files = new FormData()
        for(let i of files) {
          if(typeof app[i].name == 'string') {
            let img = app[i]
            temp_form_data_files.append('fotos', img);

            let res = await context.dispatch('upload_api', temp_form_data_files)

            console.log(res)
          }
        }

        app.close();
        app.initialize();
      }
    },
    async updateProducts(context, app) {
      let method = "product/edit/"+app.editedItem.id
      let data = await api_calls.call_api_create_prod(method, app.form_data)

      app.updateResult = data
      if (app.updateResult.resultado != "OK") {
        app.productMsg = app.updateResult.details;
      } else {
        // app.functionMsg = "Função editada com sucesso";

        let images = ['image_1', 'image_2', 'image_3', 'video']
        let temp_form_data = new FormData()
        for(let i of images) {
          if(typeof app[i].name == 'string') {
            let img = app[i]
            temp_form_data.append('fotos', img);

            let res = await context.dispatch('upload_api', temp_form_data)

            console.log(res)
          }
        }

        let files = ['link_1', 'link_2', 'link_3', 'link_4', 'link_5']
        let temp_form_data_files = new FormData()
        for(let i of files) {
          if(app[i].name && typeof app[i].name == 'string') {
            let img = app[i]
            temp_form_data_files.append('fotos', img);

            let res = await context.dispatch('upload_api', temp_form_data_files)

            console.log(res)
          }
        }

        app.close();
        app.initialize();
      }
    },
    async deleteProducts(context, app) {
      let method = "product/delete/"+app.deletedItem.id
      let data = await api_calls.call_api_get(method)

      app.updateResult = data
      if (app.updateResult.resultado != "OK") {
        app.productMsg = app.updateResult.details;
      } else {
        // app.categoryMsg = "Marca editada com sucesso";

        let images = ['image_1', 'image_2', 'image_3', 'video']
        let temp_form_data = new FormData()
        for(let i of images) {
          if(typeof app[i].name == 'string') {
            let img = app[i]
            temp_form_data.append('fotos', img);

            let res = await context.dispatch('upload_api', temp_form_data)

            console.log(res)
          }
        }
        app.close();
        app.initialize();
      }
    },

    /*UPDATED*/
    /*PRODUTOS*/
    async collectProductsFeatured(context, app) {
      let method = "product/listAllFeatured"
      let data = await api_calls.call_api_get(method)

      app.productsFeatured = Object.values(data.products)
    },
    async updateProductsFeatured(context, app) {
      let method = "product/editFeatured/"+app.editedItem.g_product_id
      let data = await api_calls.call_api_get(method)

      app.updateResult = data
      if (app.updateResult.resultado != "OK") {
        app.productMsg = app.updateResult.details;
      } else {
        // app.functionMsg = "Função editada com sucesso";

        let images = ['image_1', 'image_2', 'image_3', 'video']
        let temp_form_data = new FormData()
        for(let i of images) {
          if(typeof app[i].name == 'string') {
            let img = app[i]
            temp_form_data.append('fotos', img);

            let res = await context.dispatch('upload_api', temp_form_data)

            console.log(res)
          }
        }
        
        app.close();
        app.initialize();
      }
    },
    async deleteProductsFeatured(context, app) {
      let method = "product/deleteFeatured/"+app.deletedItem.id
      let data = await api_calls.call_api_get(method)

      app.updateResult = data
      if (app.updateResult.resultado != "OK") {
        app.productMsg = app.updateResult.details;
      } else {
        // app.functionMsg = "Função editada com sucesso";

        let images = ['image_1', 'image_2', 'image_3', 'video']
        let temp_form_data = new FormData()
        for(let i of images) {
          if(typeof app[i].name == 'string') {
            let img = app[i]
            temp_form_data.append('fotos', img);

            let res = await context.dispatch('upload_api', temp_form_data)

            console.log(res)
          }
        }
        
        app.close();
        app.initialize();
      }
    },

    /*NOVIDADES*/
    async collectNews(context, app) {
      let method = "news/listAll"
      let data = await api_calls.call_api_get(method)

      app.news = Object.values(data.news)
    },
    async createNews(context, app) {
      let method = "news/create"
      let data = await api_calls.call_api_create_prod(method, app.form_data)

      app.createResult = data
      if (app.createResult.resultado != "OK") {
        app.productMsg = app.createResult.details;
      } else {
        // app.functionMsg = "Função criada com sucesso";

        let images = ['image', 'video']
        let temp_form_data = new FormData()
        for(let i of images) {
          if(typeof app[i].name == 'string') {
            let img = app[i]
            temp_form_data.append('fotos', img);

            let res = await context.dispatch('upload_api', temp_form_data)

            console.log(res)
          }
        }

        let files = ['link_1', 'link_2', 'link_3', 'link_4', 'link_5']
        let temp_form_data_files = new FormData()
        for(let i of files) {
          if(typeof app[i].name == 'string') {
            let img = app[i]
            temp_form_data_files.append('fotos', img);

            let res = await context.dispatch('upload_api', temp_form_data_files)

            console.log(res)
          }
        }

        app.close();
        app.initialize();
      }
    },
    async updateNews(context, app) {
      let method = "news/edit/"+app.editedItem.id
      let data = await api_calls.call_api_create_prod(method, app.form_data)

      app.updateResult = data
      if (app.updateResult.resultado != "OK") {
        app.productMsg = app.updateResult.details;
      } else {
        // app.functionMsg = "Função editada com sucesso";

        let images = ['image', 'video']
        let temp_form_data = new FormData()
        for(let i of images) {
          if(typeof app[i].name == 'string') {
            let img = app[i]
            temp_form_data.append('fotos', img);

            let res = await context.dispatch('upload_api', temp_form_data)

            console.log(res)
          }
        }

        let files = ['link_1', 'link_2', 'link_3', 'link_4', 'link_5']
        let temp_form_data_files = new FormData()
        for(let i of files) {
          if(app[i].name && typeof app[i].name == 'string') {
            let img = app[i]
            temp_form_data_files.append('fotos', img);

            let res = await context.dispatch('upload_api', temp_form_data_files)

            console.log(res)
          }
        }

        app.close();
        app.initialize();
      }
    },
    async deleteNews(context, app) {
      let method = "news/delete/"+app.deletedItem.id
      let data = await api_calls.call_api_get(method)

      app.updateResult = data
      if (app.updateResult.resultado != "OK") {
        app.productMsg = app.updateResult.details;
      } else {
        // app.categoryMsg = "Marca editada com sucesso";

        let images = ['image', 'video']
        let temp_form_data = new FormData()
        for(let i of images) {
          if(typeof app[i].name == 'string') {
            let img = app[i]
            temp_form_data.append('fotos', img);

            let res = await context.dispatch('upload_api', temp_form_data)

            console.log(res)
          }
        }
        app.close();
        app.initialize();
      }
    },
    
    /*COMUNICAÇÔES*/
    async collectNewsletter(context, app) {
      let method = "newsletter/listAll"
      let data = await api_calls.call_api_get(method)

      app.newsletter = Object.values(data.newsletter)
    },
    async createNewsletter(context, app) {
      let method = "newsletter/create"
      let data = await api_calls.call_api_create_prod(method, app.form_data)

      app.createResult = data
      if (app.createResult.resultado != "OK") {
        app.productMsg = app.createResult.details;
      } else {
        // app.functionMsg = "Função criada com sucesso";

        let images = ['image', 'video']
        let temp_form_data = new FormData()
        for(let i of images) {
          if(typeof app[i].name == 'string') {
            let img = app[i]
            temp_form_data.append('fotos', img);

            let res = await context.dispatch('upload_api', temp_form_data)

            console.log(res)
          }
        }

        app.close();
        app.initialize();
      }
    },
    async updateNewsletter(context, app) {
      let method = "newsletter/edit/"+app.editedItem.id
      let data = await api_calls.call_api_create_prod(method, app.form_data)

      app.updateResult = data
      if (app.updateResult.resultado != "OK") {
        app.productMsg = app.updateResult.details;
      } else {
        // app.functionMsg = "Função editada com sucesso";

        let images = ['image', 'video']
        let temp_form_data = new FormData()
        for(let i of images) {
          if(typeof app[i].name == 'string') {
            let img = app[i]
            temp_form_data.append('fotos', img);

            let res = await context.dispatch('upload_api', temp_form_data)

            console.log(res)
          }
        }

        let files = ['link_1', 'link_2', 'link_3', 'link_4', 'link_5']
        let temp_form_data_files = new FormData()
        for(let i of files) {
          if(app[i].name && typeof app[i].name == 'string') {
            let img = app[i]
            temp_form_data_files.append('fotos', img);

            let res = await context.dispatch('upload_api', temp_form_data_files)

            console.log(res)
          }
        }

        app.close();
        app.initialize();
      }
    },
    async deleteNewsletter(context, app) {
      let method = "newsletter/delete/"+app.deletedItem.id
      let data = await api_calls.call_api_get(method)

      app.updateResult = data
      if (app.updateResult.resultado != "OK") {
        app.productMsg = app.updateResult.details;
      } else {
        // app.categoryMsg = "Marca editada com sucesso";

        let images = ['image', 'video']
        let temp_form_data = new FormData()
        for(let i of images) {
          if(typeof app[i].name == 'string') {
            let img = app[i]
            temp_form_data.append('fotos', img);

            let res = await context.dispatch('upload_api', temp_form_data)

            console.log(res)
          }
        }
        app.close();
        app.initialize();
      }
    },

    /*FARMALETTER*/
    async collectFarmaletter(context, app) {
      let method = "farmaletter/listAll"
      let data = await api_calls.call_api_get(method)

      app.farmaletter = Object.values(data.farmaletter)
    },
    async createFarmaletter(context, app) {
      let method = "farmaletter/create"
      let data = await api_calls.call_api_create_prod(method, app.form_data)

      app.createResult = data
      if (app.createResult.resultado != "OK") {
        app.productMsg = app.createResult.details;
      } else {
        // app.functionMsg = "Função criada com sucesso";

        let images = ['image', 'video']
        let temp_form_data = new FormData()
        for(let i of images) {
          if(typeof app[i].name == 'string') {
            let img = app[i]
            temp_form_data.append('fotos', img);

            let res = await context.dispatch('upload_api', temp_form_data)

            console.log(res)
          }
        }

        app.close();
        app.initialize();
      }
    },
    async deleteFarmaletter(context, app) {
      let method = "farmaletter/delete/"+app.deletedItem.id
      let data = await api_calls.call_api_get(method)

      app.updateResult = data
      if (app.updateResult.resultado != "OK") {
        app.productMsg = app.updateResult.details;
      } else {
        app.close();
        app.initialize();
      }
    },

    upload_api: async function(context, apiBody) {
      try {
          var response = await fetch('https://portal.glintt.com/assets/api/public/upload-file', {
              method: 'POST',
              headers: {},
              redirect: 'follow',
              body: apiBody
          })
          var result = await response.json()
          return result
      }
      catch (error) {
          console.error('Error:', error)
          return 'Error: ' + error
      }
    }
  },
  
  modules: {
  }
})
